<template>
  <div class="container-fluid" ref="container">
    <div class="row">
      <div class="col-md last-update" v-bind:class="{'text-right': window.isMobile != true,'text-center': window.isMobile == true}">{{$t("UpdateTime")}}{{lastUpdate}}</div>
    </div>
    <div class="row">
      <div class="col-lg-6 left" ref="divLeft" v-bind:style="divLeftStyle">
        <!--  -->
        <div class="text-center method-selector p-3">
          <b-button-group>
            <b-button size="sm" v-for="btn in options" :key="btn.value" v-on:click="mode = btn.value" :variant="mode == btn.value ? 'info' : ''"
              v-b-tooltip.hover :title="$t('button.'+btn.value+'.title')" placement="bottom">
              {{$t("button."+btn.value+".text")}}
            </b-button>
          </b-button-group>
          <!-- <b-button-group>
            <b-button size="sm" v-b-tooltip.hover :title='$t("button.Location")' placement="bottom" v-on:click="getCurrentPosition" style="padding: 4px 4px 4px 4px; display: flex;">
              <i class="material-icons" style="font-size: 21px;">my_location</i>
            </b-button>
          </b-button-group> -->
        </div>
        <div id="divChartViewMap" ref="divChart">
          <div class="chartIsland">
            <!-- <div style="color: #FFF">{{document.body.scrollHeight}} {{document.body.scrollTop}} {{document.body.scrollTop}} {{document.body.offsetHeight}}</div> -->
            <div class="islandItem divChartLianjiang" ref="divChartLianjiang">
              <div class="title">{{$t('RegionName.Lianjiang')}}</div>
              <div class="chart Lianjiang"
                v-on:mouseover="chartMouseover(mapFeaturesLianjiang[0]); focusIslands=1"
                v-on:mousemove="chartMousemove"
                v-on:mouseleave="chartMouseleave(mapFeaturesLianjiang[0]);"
                v-if="mapFeaturesLianjiang[0].data"
                v-bind:class="{'focus': focusIslands==0||focusIslands==1, 'check_circle': mapFeaturesLianjiang[0].data.ratio < .15, 'warning': mapFeaturesLianjiang[0].data.ratio >= .15 && mapFeaturesLianjiang[0].data.ratio < .2, 'error': mapFeaturesLianjiang[0].data.ratio >= .2}"
              >
              </div>
            </div>
            <div class="islandItem divChartKinmen" ref="divChartKinmen">
              <div class="title">{{$t('RegionName.Kinmen')}}</div>
              <div class="chart Kinmen"
                v-on:mouseover="chartMouseover(mapFeaturesKinmen[0]); focusIslands=2"
                v-on:mousemove="chartMousemove"
                v-on:mouseleave="chartMouseleave(mapFeaturesLianjiang[0]);"
                v-if="mapFeaturesKinmen[0].data"
                v-bind:class="{'focus': focusIslands==0||focusIslands==2,'check_circle': mapFeaturesKinmen[0].data.ratio < .15, 'warning': mapFeaturesKinmen[0].data.ratio >= .15 && mapFeaturesKinmen[0].data.ratio < .2, 'error': mapFeaturesKinmen[0].data.ratio >= .2}"
              ></div>
            </div>
            <div class="islandItem divChartPenghu" ref="divChartPenghu">
              <div class="title">{{$t('RegionName.Penghu')}}</div>
              <div class="chart Penghu"
                v-on:mouseover="chartMouseover(mapFeaturesPenghu[0]); focusIslands=3"
                v-on:mousemove="chartMousemove"
                v-on:mouseleave="chartMouseleave(mapFeaturesLianjiang[0]);"
                v-if="mapFeaturesPenghu[0].data"
                v-bind:class="{'focus': focusIslands==0||focusIslands==3,'check_circle': mapFeaturesPenghu[0].data.ratio < .15, 'warning': mapFeaturesPenghu[0].data.ratio >= .15 && mapFeaturesPenghu[0].data.ratio < .2, 'error': mapFeaturesPenghu[0].data.ratio >= .2}"
              ></div>
            </div>
          </div>
          
          <div class="chartItems ml-5">
            <div class="chartItem d-flex align-items-center">
              <div class="customs-icons error"></div>
              <div class="describe ml-2">{{$t("ViewMaps.WarningLight.Error")}}</div>
            </div>
            <div class="chartItem d-flex align-items-center">
              <div class="customs-icons warning"></div>
              <div class="describe ml-2">{{$t("ViewMaps.WarningLight.Warning")}}</div>
            </div>
            <div class="chartItem d-flex align-items-center">
              <div class="customs-icons check_circle"></div>
              <div class="describe ml-2">{{$t("ViewMaps.WarningLight.OK")}}</div>
            </div>
          </div>
          
          <div class="divDataInfo" v-if="showDataInfo" v-bind:style="{left: divInfoPath[0]+'px', top: divInfoPath[1]+'px'}">
            <div class="County">{{ $t('RegionName.'+ RegionTranslate(focusCounty.properties.C_Name) ) }}</div>
            <div class="status">
              <div class="customs-icons3" v-bind:class="{'check_circle': focusCounty.data.ratio < .15, 'warning': focusCounty.data.ratio >= .15 && focusCounty.data.ratio < .2, 'error': focusCounty.data.ratio >= .2 }"></div>
              <div>{{focusCounty.data.ratio < .15 ? $t('WarningLight.OK') : (focusCounty.data.ratio >= .15 && focusCounty.data.ratio < .2 ? $t('WarningLight.Warning') : $t('WarningLight.Error'))}}</div>
            </div>
            <div class="thisWeekNum">{{getNumberofPeople(focusCounty.data.thisWeekNum)}}
              <label v-bind:class="focusCounty.data.ratio>0? 'arrow_drop_up': 'arrow_drop_down'">
                <i class="material-icons">
                  {{focusCounty.data.ratio>0? 'arrow_drop_up': 'arrow_drop_down'}}
                </i>
                {{getNumberofPercent(Math.abs(focusCounty.data.ratio))}}</label>
            </div>

          </div>
        </div>
      </div>

      <div class="col-lg-6 right px-0" v-on:scroll="scrollFunction($event)">
        <div class="info pt-3 p-3">
          <div class="title">{{$t("Navbar.ViewMaps")}}</div>
          <div class="describe">{{$t("ViewMaps.PageDescribe")}}</div>
          <div class="container-fluid">
            <div class="row no-gutters">
              <div class="col-lg-6" v-if="Data.arrRegion" v-for="item,index in Data.arrRegion">
                <div class="divTable mb-3 border border-info mr-3" v-bind:style="getDivTableHeight(index)">
                  <div class="region-name p-2">
                    <div class="region">{{ $t('RegionName.'+RegionTranslate(item.Region)) }}</div>
                    <div class="moveToRegion">
                      <router-link :to="{name: 'EachRegionWithRegion', params: {'Region_Eng': item.Region_Eng}}"><a>{{$t("ViewMaps.View")}} {{$t("ViewMaps.Trends")}}<i class="material-icons">arrow_forward_ios</i></a></router-link>
                    </div>
                  </div>
                  <table class="table table-hover">
                    <thead class="thead-light">
                      <tr class="tr-info">
                        <th style="width: 30%; display: table-cell; vertical-align: middle;">{{$t("ViewMaps.Region")}}</th>
                        <th style="width: 30%; display: table-cell; vertical-align: middle;">{{$t("ViewMaps.PredictOfStatus")}}</th>
                        <th style="width: 40%; ">{{$t('ViewMaps.NextWeekPredict1')}}</br>{{$t('ViewMaps.NextWeekPredict2')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-bind:class="{'table-active': (focusCounty != undefined ? focusCounty.properties.County_ID : undefined) == item2.County_ID}"
                        v-for="item2 in item.County" v-on:mouseenter="tblMouseEnter(item2)" v-on:mouseleave="tblMouseLeave">
                        <td>
                          <div class="label">{{ $t('RegionName.'+ RegionTranslate(item2.C_Name) ) }}</div>
                        </td>
                        <td>
                          <div class="describe">
                            <div class="customs-icons2" v-bind:class="item2.ratio>=.2? 'error': item2.ratio<.2&&item2.ratio>.15? 'warning' : 'check_circle'">
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>{{getNumberofPeople(item2.thisWeekNum)}}</div>
                          <div class="ratio">
                            <i class="material-icons">
                              {{item2.ratio>0? 'arrow_drop_up': 'arrow_drop_down'}}
                            </i>
                            {{getNumberofPercent(Math.abs(item2.ratio))}}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as d3 from "d3";
  import * as topojson from "topojson";
  import Vue from "vue";

  export default {
    name: "ViewMaps",
    components: {},
    data() {
      return {
        window: window,
        document: document,
        divLeftStyle:{
          top: this.getScreenMaxWidth() < 991 ?'0px':'60px'
        },
        lastUpdate: undefined,
        isLoading: true,
        focusCounty: undefined,
        focusIslands: 0,
        mapFeaturesMainIsland: undefined,
        mapFeaturesLianjiang: [{data: {ratio: 0}}],
        mapFeaturesKinmen: [{data: {ratio: 0}}],
        mapFeaturesPenghu: [{data: {ratio: 0}}],
        divInfoPath: undefined,
        showDataInfo: false,
        mode: "RODS_NHI",
        options: [{
            value: "RODS_NHI",
            text: "總就診人次",
            title: "來源：健保資料庫+RODS"
          },
          {
            value: "NHI",
            text: "門診",
            title: "來源：健保資料庫"
          },
          {
            value: "RODS",
            text: "急診",
            title: "來源：RODS"
          }
        ],
        width: 690,
        height: 460,
        Data: {
          arrRegion: []
        },
        RegionMapping: {
          "63": "台北區",
          "64": "高屏區",
          "65": "台北區",
          "66": "中區",
          "67": "南區",
          "68": "北區",
          "09007": "台北區",
          "09020": "台北區",
          "10002": "台北區",
          "10004": "北區",
          "10005": "北區",
          "10007": "中區",
          "10008": "中區",
          "10009": "南區",
          "10010": "南區",
          "10013": "高屏區",
          "10014": "東區",
          "10015": "東區",
          "10016": "高屏區",
          "10017": "台北區",
          "10018": "北區",
          "10020": "南區"
        },
        randomValue: Math.random()
      };
    },
    methods: {
      RegionTranslate: function(string){
        let ArrRegionMapping = {
          "台北區": "GreaterTaipei",
          "北區": "NorthArea",
          "中區": "CentralArea",
          "南區": "SouthArea",
          "高屏區": "KaohsiungPingtungArea",
          "東區": "EastArea",
          "臺北市": "Taipei",
          "新北市": "NewTaipei",
          "連江縣": "Lianjiang",
          "金門縣": "Kinmen",
          "宜蘭縣": "Yilan",
          "基隆市": "Keelung",

          "桃園市": "Taoyuan",
          "新竹縣": "HsinchuCounty",
          "苗栗縣": "Miaoli",
          "新竹市": "HsinchuCity",
          "臺中市": "Taichung",
          "彰化縣": "Changhua",
          "南投縣": "Nantou",
          "臺南市": "Tainan",
          "雲林縣": "Yunlin",
          "嘉義縣": "ChiayiCounty",
          "嘉義市": "ChiayiCity",
          "高雄市": "Kaohsiung",
          "屏東縣": "Pingtung",
          "澎湖縣": "Penghu",
          "臺東縣": "Taitung",
          "花蓮縣": "Hualien"
        }

        return ArrRegionMapping[string]
      },
      getDivTableHeight: function(index){
        let styleObject = undefined;
        switch(index){
          case 0:
            styleObject = {'min-height': '469px'}
          break;
          case 1:
            styleObject = {'min-height': '469px'}
          break;
          case 2:
            styleObject = {'min-height': '355px'}
          break;
          case 3:
            styleObject = {'min-height': '355px'}
          break;
          case 4:
            styleObject = {'min-height': '298px'}
          break;
          case 5:
            styleObject = {'min-height': '298px'}
          break;
        }

        return styleObject
      },
      scrollFunction: function(event){
        let Interval;
        let remainValue = Math.abs(event.deltaY);
        let scrollInterval = 10;

        document.body.scrollTop += event.deltaY/2.5;
      },
      getScreenMaxWidth: function(){
        return Math.max(
          document.body.scrollWidth,
          document.documentElement.scrollWidth,
          document.body.offsetWidth,
          document.documentElement.offsetWidth,
          document.documentElement.clientWidth
        )
      },
      bodyScrollListener: function(event){
        // if(window.isMobile){
        //   this.divLeftStyle.top = '0px';
        // }
        if( this.getScreenMaxWidth() < 991){
          this.divLeftStyle.top = '0px';
        }
        else{
          let totalHeight = document.body.scrollHeight;
          let scrollValue = document.body.scrollTop + document.body.offsetHeight;
          let el = document.scrollingElement || document.documentElement;
          this.divLeftStyle.top = 
            document.body.scrollHeight == document.body.offsetHeight ? '60px' : 
              (
                document.body.scrollHeight - (document.body.scrollTop + document.body.offsetHeight)  > 60 ? (60+'px') : 
                (document.body.scrollHeight - (document.body.scrollTop + document.body.offsetHeight)) + 'px'
              )
            ;
          //alert(document.body.scrollTop)
          //alert(Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop, document.scrollingElement.scrollTop))
          //this.divLeftStyle.top = (60-(document.body.scrollTop>60?60:document.body.scrollTop))+'px';
        }
      },
      initialTaiwanMaps: function () {
        var _this = this;
        d3.json("static/TaiwanCounty.json", function (topodata) {
          _this.mapFeaturesMainIsland = topojson.feature(
            topodata,
            topodata.objects["county"]
          ).features;

          //Get data
          _this.getChartData();

          //Find Lianjiang, Kinmen, Penghu
           _this.mapFeaturesLianjiang = _this.mapFeaturesMainIsland.filter((d)=>{
             return d.properties.C_Name == '連江縣'
           })
           _this.mapFeaturesKinmen = _this.mapFeaturesMainIsland.filter((d)=>{
             return d.properties.C_Name == '金門縣'
           })
           _this.mapFeaturesPenghu = _this.mapFeaturesMainIsland.filter((d)=>{
             return d.properties.C_Name == '澎湖縣'
           })

          var svg = d3
            .select(_this.$refs.divChart)
            .append("svg")
            .attr("width", `100%`)
            .attr("class", "svgMain")
            .attr("viewBox", `-50 0 ${_this.width} ${_this.height}`)
            .attr("perserveAspectRatio", "xMinYMid");

          svg
            .selectAll("path")
            .data(_this.mapFeaturesMainIsland.filter((d)=>{
              return d.properties.C_Name != '連江縣' &&
              d.properties.C_Name != '金門縣' &&
              d.properties.C_Name != '澎湖縣' 
            }))
            .enter()
            .append("path")
              .attr("d", d3.geoPath().projection(
              d3
              .geoMercator()
              .center([121.95, 23.3])
              .scale(6000)
            ))
            .attr("class", function (d) {
              return `pathCounty pathCounty_${d.properties.County_ID}`;
            })
          d3.selectAll(".pathCounty")
            .on("mouseover", d => {
              _this.chartMouseover(d)
            })
            .on("mousemove", function (d) {
              _this.chartMousemove(d)
            })
            .on("mouseleave", () => {
              _this.chartMouseleave();
            });

        });
      },
      chartMouseover: function(obj){
        this.focusIslands = -1;
        
        if(obj.properties.C_Name == '連江縣'){
          this.focusIslands = 1;
        }
        if(obj.properties.C_Name == "金門縣"){
          this.focusIslands = 2;
        }
        if(obj.properties.C_Name == '澎湖縣'){
          this.focusIslands = 3;
        }

        d3
          .selectAll(`.pathCounty`)
          .transition()
          .duration(200)
          .style("opacity", 0.4);
        d3
          .select(`.pathCounty_${obj.properties.County_ID}`)
          .transition()
          .duration(100)
          .style("opacity", 1);
        this.focusCounty = obj;
      },
      chartMousemove: function(d){
        let x = (d.clientX) || (d3.event!=null?d3.event.pageX:undefined - this.$refs.divChart.getBoundingClientRect().x - window.pageXOffset + 15);
        let y = (d.clientY - 80) || (d3.event!=null?d3.event.pageY:undefined - this.$refs.divChart.getBoundingClientRect().y - window.pageYOffset + 15);
        let limitHeight = this.$refs['divLeft'].offsetHeight;
        let limitWidth = this.$refs['divLeft'].offsetWidth;
        //console.log((x+15),limitWidth)
        this.divInfoPath = [(x+160)>limitWidth?x-160:(x+15),(y+100)>limitHeight?limitHeight-260:(y-100)];
        this.showDataInfo = true;
      },
      chartMouseleave: function(){
        this.tblMouseLeave();
        this.focusCounty = undefined;
        this.showDataInfo = false;
        this.focusIslands = 0;
      },
      getNumberofPeople: function (val) {
        return d3.format(",.0f")(val);
      },
      getNumberofPercent: function (val) {
        return val === undefined ? "" : d3.format(".2%")(val);
      },
      getChartEachData: function(FileName){
        return new Promise((resolve, reject)=>{
          Vue.axios
          .get(
            `static/Data/Influenza_Map/${this.mode}/${FileName}?rand=${this.randomValue}`
          )
          .then(res => {
            if (res.status != 200) {
              //get file error
            } else {
               resolve(res.data)
               this.Data += res.data;
            }
          })
        })
      },

      recursiveWorker: function(regionList, oriRegionListLength, keeper){
        return new Promise((resolve, reject)=>{
          let tmp;
          if(regionList.length == oriRegionListLength) keeper = resolve;

          if(regionList.length != 0){
            tmp = regionList.pop();
            this.getChartEachData(tmp).then(()=>{
              this.recursiveWorker(regionList, -1, keeper)
            });
          }
          else {
            keeper(undefined); 
          }
        })
      },
      getChartData: function () {
        let _this = this;
        let regionList = ['Central_Area_county_predict.csv', 'East_Area_county_predict.csv', 'Greater_Taipei_county_predict.csv', 'Kao_Ping_county_predict.csv', 'North_Area_county_predict.csv', 'South_Area_county_predict.csv'];
        //Get data
        this.Data = "";
        let keeper;

        this.recursiveWorker(regionList, regionList.length, keeper).then((d)=>{
          //remove invalid header
          _this.Data = d3.csvParse(_this.Data).map(d => {
            return {
              C_Name: d.county,
              thisWeekNum: +d.thisWeekPredict,
              ratio: +d.ratio
            };
          }).filter((d)=>{
            return !isNaN(d.ratio);
          });

          for (let i = 0; i < _this.Data.length; i++) {
            let mapTarget = _this.mapFeaturesMainIsland.find(d => {
              return d.properties.C_Name == _this.Data[i].C_Name;
            });
            _this.Data[i].County_ID = mapTarget.properties.County_ID;
            mapTarget.data = _this.Data[i];
            // //Change color
            d3
              .selectAll(`.pathCounty_${_this.Data[i].County_ID}`)
              .transition()
              .duration(200)
              .style("fill", () => {
                if (_this.Data[i].ratio > 0.2) return "#F44336";
                if (_this.Data[i].ratio <= 0.2 && _this.Data[i].ratio > 0.15)
                  return "#ffc107";
                else return "#4CAF50";
              });
          }
          _this.Data.forEach(d => {
            d.Region = _this.RegionMapping[d.County_ID];
          });

          //_this.Data.sort((a,b)=>{return parseInt(a.County_ID) > parseInt(b.County_ID) ? 1 : -1})
          _this.Data.sort((a, b) => {
            return parseInt(a.County_ID) > parseInt(b.County_ID) ? 1 : -1;
          });

          _this.Data.arrRegion = [{
              Region: "台北區",
              Region_Eng: "Greater_Taipei",
              County: []
            },
            {
              Region: "北區",
              Region_Eng: "North_Area",
              County: []
            },
            {
              Region: "中區",
              Region_Eng: "Central_Area",
              County: []
            },
            {
              Region: "南區",
              Region_Eng: "South_Area",
              County: []
            },
            {
              Region: "高屏區",
              Region_Eng: "Kao_Ping",
              County: []
            },
            {
              Region: "東區",
              Region_Eng: "East_Area",
              County: []
            }
          ];

          _this.Data.arrRegion.forEach(d => {
            d.County = _this.Data.filter(_d => {
              return _d.Region == d.Region;
            });
          });
          _this.isLoading = false;
          //Detect geo
          // navigator.permissions.query({name:'geolocation'}).then((result)=> {
          //   if(result.state == 'granted'){
          //     this.getCurrentPosition();
          //   }
          // });
        })
      },
      tblMouseEnter: function (d) {
        d3
          .selectAll(`.pathCounty`)
          .transition()
          .duration(200)
          .style("opacity", 0.4);
        d3
          .select(`.pathCounty_${d.County_ID}`)
          .transition()
          .duration(100)
          .style("opacity", 1);

        let path = d3.select(".pathCounty_"+d.County_ID)
        let objRegion = this.mapFeaturesMainIsland.find((_d)=>{ return _d.properties.County_ID == d.County_ID})
        this.chartMouseover(objRegion)
        if(path.node() != null){
          this.chartMousemove({
            clientX: path.node().getBoundingClientRect().x ||path.node().getBoundingClientRect().left, 
            clientY: path.node().getBoundingClientRect().y ||path.node().getBoundingClientRect().top})
        }
        if(d.C_Name == '連江縣'){
          this.chartMousemove({clientX: 230, clientY: (this.$refs['divChartLianjiang'].getBoundingClientRect().y || this.$refs['divChartLianjiang'].getBoundingClientRect().top)+50})
        }
        if(d.C_Name == "金門縣"){
          this.chartMousemove({clientX: 230, clientY: (this.$refs['divChartKinmen'].getBoundingClientRect().y || this.$refs['divChartKinmen'].getBoundingClientRect().top)+50})
        }
        if(d.C_Name == '澎湖縣'){
          this.chartMousemove({clientX: 230, clientY: (this.$refs['divChartPenghu'].getBoundingClientRect().y || this.$refs['divChartPenghu'].getBoundingClientRect().top)+50})
        }


      },
      tblMouseLeave: function (d) {
        d3
          .selectAll(`.pathCounty`)
          .transition()
          .duration(100)
          .style("opacity", 1);
      },
      getLastUpdate: function () {
        Vue.axios
          .get(
            `https://fluforecast.cdc.gov.tw/WebService/getFileUpdateTimeViewMaps.php`
          )
          .then(res => {
            if (res.status != 200) {} else {
              this.lastUpdate = res.data;
            }
          });
      },
      getLastWeek: function () {
        Vue.axios.get(`?rand=${this.randomValue}`).then(res => {
          d3.csvParse(res.data, (d, i) => {
            this.lastWeek = d.yearWeek.substring(4, 6);
          });
        });
      },
      getCurrentPosition: function() {
        let lat, lon;
        navigator.geolocation.getCurrentPosition((d)=>{
          lat = d.coords.latitude;
          lon = d.coords.longitude;
          Vue.axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&key=AIzaSyBOxxAj0ct5QhCs8JH-Wilap3Xwo_arcxk`)
            .then(res=>{
              let objGoogleResponse = res.data.results
              if(objGoogleResponse.length == 0){
                window.alert("無法取得目前位置，請稍後再試。(Code：1)")
              }
              else{
                let objAreaLevel1 = objGoogleResponse[0].address_components.find((d)=>{
                  for(let i=0;i<d.types.length;i++){
                    if(d.types[i] == 'administrative_area_level_1' || d.types[i] == 'administrative_area_level_2') return d;
                  }
                })

                //Highlight the county
                let objRegion = this.mapFeaturesMainIsland.find((d)=>{ return d.properties.C_Name == objAreaLevel1.long_name.replace("台", "臺")})
                if(objRegion == undefined){
                  window.alert("無法取得目前位置，請稍後再試。(Code：2)")
                }
                else{
                  this.chartMouseover(objRegion)
                  let path = d3.select(".pathCounty_"+objRegion.properties.County_ID)
                  this.chartMousemove({clientX: path.node().getBoundingClientRect().x, clientY: path.node().getBoundingClientRect().y})
                }
              }
            })
        })
      }
    },
    mounted: function () {
      this.getLastUpdate();
      this.initialTaiwanMaps();

      //Add left div listener
      this.$refs.divLeft.addEventListener('wheel', this.scrollFunction)

      //Add body listener
      document.body.addEventListener('scroll', this.bodyScrollListener)

    },
    destroyed: function(){
      document.body.removeEventListener('scroll', this.bodyScrollListener);
    },
    watch: {
      mode: function () {
        this.isLoading = true;

        this.$ga.event({
          eventCategory: "ViewMaps",
          eventAction: "ChangeType",
          eventLabel: this.mode
        });
        this.getChartData();
      }
    },
    scrollY: function(){
      
    }
  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .pathCounty {
    fill: none;
    stroke-width: 0.05rem;
    stroke: #fff;
  }

</style>
<style lang="scss" scoped>
@import '../scss/_rwd.scss';
  @keyframes flash {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }

  .last-update {
    color: #fff;
    font-size: 14px;
    margin-left: 15px;
    margin-right: 15px;
  }

  .method-selector {
    color: #fff;
    .loading {
      margin-left: 4px;
      margin-top: 4px;
    }
    .loading-bar {
      display: inline-block;
      width: 4px;
      height: 18px;
      border-radius: 4px;
      animation: loading 1s ease-in-out infinite;
    }
    .loading-bar:nth-child(1) {
      background-color: #3498db;
      animation-delay: 0;
    }
    .loading-bar:nth-child(2) {
      background-color: #c0392b;
      animation-delay: 0.09s;
    }
    .loading-bar:nth-child(3) {
      background-color: #f1c40f;
      animation-delay: 0.18s;
    }
    .loading-bar:nth-child(4) {
      background-color: #27ae60;
      animation-delay: 0.27s;
    }

    @keyframes loading {
      0% {
        transform: scale(1);
      }
      20% {
        transform: scale(1, 2.2);
      }
      40% {
        transform: scale(1);
      }
    }
  }

  .container-fluid {
    padding: 0px;
    max-width: 1920px;
    .left{
      top: 60px;
      min-height: 415px;
      @include lg-width(){
        position: fixed;
        height: calc(100vh - 60px);
      }
      @include xl-width(){
        position: fixed;
        height: calc(100vh - 60px);
      }
      #divChartViewMap{
        height: 88%;
        position: relative;

        .chartItem {
          color: #fff;
          .describe {
            font-size: 14px;
          }
        }

        .chartIsland{
          position: absolute;
          left: 10%;
          @include xs-width(){
            bottom: 5%;
          }
          @include sm-width(){
            bottom: 10%;
          }
          @include md-width(){
            bottom: 15%;
          }
          @include lg-width(){
            top: 120px;
          }
          @include xl-width(){
            bottom: 30px;
          }

          @media (max-height: 650px) {
            top: 112px !important;
          }
          
          .islandItem{
            .title{
              padding-top: 8px;
              padding-left: 16px;
            }

            .chart{
              width: 100%;
              height: calc(100% - 32px);
              background-size: auto calc(100% - 10px);
              background-position: center;
              background-repeat: no-repeat;
              opacity: .4;
              -webkit-transition: opacity .4s ease 0s;
              &.focus{
                opacity: 1;
                -webkit-transition: opacity .4s ease 0s;
              }
              &.Lianjiang{
                &.check_circle{
                  background-image: url('../../static/images/Map/Lianjiang/good.png')
                }
                &.warning{
                  background-image: url('../../static/images/Map/Lianjiang/warning.png')
                }
                &.error{
                  background-image: url('../../static/images/Map/Lianjiang/error.png')
                }
              }
              &.Kinmen{
                &.check_circle{
                  background-image: url('../../static/images/Map/Kinmen/good.png')
                }
                &.warning{
                  background-image: url('../../static/images/Map/Kinmen/warning.png')
                }
                &.error{
                  background-image: url('../../static/images/Map/Kinmen/error.png')
                }
              }
              &.Penghu{
                &.check_circle{
                  background-image: url('../../static/images/Map/Penghu/good.png')
                }
                &.warning{
                  background-image: url('../../static/images/Map/Penghu/warning.png')
                }
                &.error{
                  background-image: url('../../static/images/Map/Penghu/error.png')
                }
              }
            }

            @include xs-width(){
              width: 90px;
              height: 70px;
              .title{
                font-size: 12px;
                padding-top: 4px;
                padding-left: 8px;
              }
            }
            @include sm-width() {
              width: 160px;
              height: 110px;
              .title{
                font-size: 12px;
                padding-top: 4px;
                padding-left: 8px;
              }
            }
            @include md-width() {
              width: 160px;
              height: 110px;
            }
            @include lg-width(){
              width: 140px;
              height: 96px;
            }
            @include xl-width(){
              width: 160px;
              height: 110px;
            }
            color: #FFF;
            margin-bottom: 14px;
            border-radius: 8px;
            border: solid 1px #ffffff;

          }
        }
      }
    }
    .right{
      @include lg-width(){
        margin-left: 50%;
      }
      @include xl-width(){
        margin-left: 50%;
      }

      min-height: 1024px;
    }
  }

  .divDataInfo {
    position: absolute;
    color: #fff;
    pointer-events: none;
    opacity: 1;
    z-index: 2;
    transition: visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1),
    left 0.4s cubic-bezier(0.23, 1, 0.32, 1),
    top 0.4s cubic-bezier(0.23, 1, 0.32, 1);

    background-color: rgba(96, 125, 139, 0.9);
    border-radius: 4px;
    padding: 12px;
    font-size: 14px;

    min-width: 130px;
    .County {
      font-weight: bold;
      font-size: 14px;
    }
    .status{
      display: flex;
      align-items: center;
      font-size: 18px;
    }
    .thisWeekNum {
      display: flex;
      label {
        display: flex;
        margin: 0;
      }
      label.arrow_drop_down {
        //color: #4caf50;
        color: #d3d1d1;
      }
      label.arrow_drop_up {
        //color: #f44336;
        color: #d3d1d1;
      }
    }
  }

  .customs-icons, .customs-icons3{
    width: 32px;
    height: 30px;
    &.check_circle,&.warning,&.error{
      background-size: 32px 30px;
    }
  }

  .customs-icons2{
    width: 40px;
    height: 38px;
    &.check_circle,&.warning,&.error{
      background-size: 40px 38px;
    }
  }

  .customs-icons.check_circle, .customs-icons2.check_circle, .customs-icons3.check_circle {
    color: #4caf50;
    margin-left: 4px;
    background-image: url('../../static/images/icons/good-lg.png');
    background-position: center center;
    background-repeat: no-repeat;
  }

  .customs-icons.warning, .customs-icons2.warning, .customs-icons3.warning {
    color: #ffc107;

    margin-left: 4px;
    background-image: url('../../static/images/icons/warning-lg.png');
    background-position: center center;
    background-repeat: no-repeat;

    animation-name: flash;
    animation-duration: 1s;
    animation-iteration-count: 8;
  }

  .customs-icons.error, .customs-icons2.error, .customs-icons3.error {
    color: #f44336;

    margin-left: 4px;
    background-image: url('../../static/images/icons/error-lg.png');
    background-position: center center;
    background-repeat: no-repeat;

    animation-name: flash;
    animation-duration: 1s;
    animation-iteration-count: 8;
  }

  .info {
    .title {
      font-size: 18px;
      color: #fff;
    }
    .describe {
      font-size: 14px;
      color: #d1d1d1;
      margin-bottom: 8px;
    } 
  }

  .divTable {
    background-color: #fff;
    border-radius: 4px;
    color: #000;
    
    .region-name {
      // margin-bottom: 4px;
      color: #607d8b;
      font-size: 18px;
      font-weight: bold;

      display: flex;
      flex-direction: row;
      align-items: center;

      div{
        display: flex;
        flex-direction: row;
        &.region{
        }
        &.moveToRegion{
          margin-left: auto;
          font-size: 14px;
          a{      
            color: #607d8b;
          }
          i{
            padding-left: 2px;
            color: #607d8b;
            font-size: 14px;
          }
        }
      }
    }
    table {
      thead {
        tr {
          font-size: 14px;
          &.tr-info{
            @include lg-width(){
              font-size: 11px;
            }
          }
        }
      }
      tbody {
        tr {
          &.table-active {
            td {
              background-color: transparent;
            }
          }
          td:first-child {
            display: flex;
          }
          td {
            display: table-cell;
            vertical-align: middle;
            padding: 4px 8px;
          }
          div.ratio {
            display: flex;
            font-size: 14px;
            color: #737373;
          } 
        }
      }
    }
  }

  .mr-3{
    @include xs-width(){
      margin-right: 0px !important;
    }
  }

</style>

<style lang="scss">
@import '../scss/_rwd.scss';
.svgMain{
  @include xs-width(){
  }
  @include md-width() {
  }
  @include lg-width(){
  }
  @include xl-width(){
    height: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ViewMaps.vue